import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {castArray} from '@coolcolduk/util';
import {Job} from '@cp/model';
import {CREATE_QUESTION_GENERATION_JOB} from '../sharedQueries';

export function useCreateQuestionGenerationJob() {
  const [createQuestionGenerationJobMutation, {loading, error}] = useMutation<
    {createQuestionGenerationJob: Job},
    {moduleId: string; topics: string[]; difficulties?: number[]; count?: number}
  >(CREATE_QUESTION_GENERATION_JOB);

  const createQuestionGenerationJob = async (
    moduleId: string,
    topics: string[],
    difficulties?: number | number[],
    count?: number,
  ) => {
    const result = await createQuestionGenerationJobMutation({
      variables: {moduleId, topics, difficulties: difficulties ? castArray(difficulties) : undefined, count},
    });

    return extractGqlData(result).createQuestionGenerationJob;
  };

  return {
    createQuestionGenerationJob,
    loading,
    error,
  };
}
